import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'main-header-detail',
  templateUrl: './header-detail.component.html'
})
export class HeaderDetailComponent implements OnInit {
  @Input() attribute: string;

  constructor() { }

  ngOnInit() {
  }

}
